import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 dakika
      gcTime: 5 * 60 * 1000, // 5 dakika
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
